import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

export default function TermsOfService() {
  return (
    <div className="page-wrapper" style={{ paddingTop: '80px' }}>
      <SEOHead
        title="Terms of Service — Redcubical Systems"
        description="Terms of Service for Redcubical Systems products including HealHub, Suraksha, and Vedant."
        canonical="/terms-of-service"
      />

      <section style={{
        padding: '80px 32px 120px',
        background: 'var(--black)',
        minHeight: '100vh',
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>

          {/* Header */}
          <div style={{ marginBottom: '56px' }}>
            <span className="section-label" style={{ marginBottom: '16px' }}>
              Legal
            </span>
            <h1 style={{
              fontFamily: 'Barlow Condensed, sans-serif',
              fontSize: 'clamp(36px, 6vw, 64px)',
              fontWeight: '900', color: '#fff',
              textTransform: 'uppercase',
              lineHeight: 1.05, marginBottom: '16px',
            }}>
              TERMS OF SERVICE
            </h1>
            <p style={{
              fontSize: '14px',
              color: 'rgba(255,255,255,0.35)',
            }}>
              Last updated: February 2026 ·
              Applies to all Redcubical Systems products and services
            </p>
          </div>

          {/* Content */}
          <div style={{
            display: 'flex', flexDirection: 'column', gap: '40px',
          }}>
            {[
              {
                title: '1. Acceptance of Terms',
                content: `By accessing or using any product or service provided by Redcubical Systems Private Limited ("Redcubical", "we", "us", or "our"), you agree to be bound by these Terms of Service. If you do not agree to these terms, you may not use our products or services.

These terms apply to all visitors, users, and others who access or use our products including HealHub, Suraksha, Vedant, HealHub Nexus, and our website at redcubicalsystems.com.`,
              },
              {
                title: '2. Description of Services',
                content: `Redcubical Systems provides the following software products and services:

HealHub: A cloud-based clinic management software platform for healthcare providers.

HealHub Nexus: A professional network for verified medical practitioners, integrated within HealHub.

Suraksha: An AI-powered anti-fraud mobile application for Android and iOS (currently in development).

Vedant: An AI-powered receptionist system for clinic deployment (currently in development).

Software Services: Custom software development, staff augmentation, AI integration, and UX/UI design services for clients.`,
              },
              {
                title: '3. User Accounts',
                content: `To access certain features of our products, you must create an account. You are responsible for:

— Maintaining the confidentiality of your account credentials
— All activities that occur under your account
— Notifying us immediately of any unauthorised use of your account
— Ensuring all information you provide is accurate and current

We reserve the right to suspend or terminate accounts that violate these terms.`,
              },
              {
                title: '4. Acceptable Use',
                content: `You agree not to use our products or services to:

— Violate any applicable laws or regulations of India or any other jurisdiction
— Transmit false, misleading, or fraudulent information
— Attempt to gain unauthorised access to our systems or other users' accounts
— Distribute malware, viruses, or other harmful code
— Scrape, copy, or reproduce our products without written permission
— Impersonate any person, clinic, or organisation
— Use our products in any manner that could damage, disable, or impair our services`,
              },
              {
                title: '5. Healthcare Data (HealHub)',
                content: `For HealHub users specifically:

You acknowledge that you are the data controller for all patient data entered into HealHub. Redcubical Systems acts as a data processor on your behalf.

You are responsible for obtaining appropriate patient consent for data collection and processing in accordance with applicable Indian laws.

You must not enter fictitious patient data or use HealHub for any purpose other than legitimate clinic management.

In the event of a data breach, you must notify your patients as required by applicable law. We will notify you of any breach affecting our systems within 72 hours of discovery.`,
              },
              {
                title: '6. Payment Terms',
                content: `For paid subscriptions:

All prices are listed in Indian Rupees (INR) and include applicable taxes.

Subscriptions are billed in advance for the selected period (monthly, quarterly, semi-annual, or annual).

Refunds are available within 7 days of subscription start for annual plans, and are not available for monthly plans after the billing date.

We reserve the right to change pricing with 30 days' notice to existing subscribers.`,
              },
              {
                title: '7. Intellectual Property',
                content: `All content, features, and functionality of our products — including but not limited to text, graphics, logos, software code, and design — are the exclusive property of Redcubical Systems Private Limited and are protected by Indian and international intellectual property laws.

You may not copy, modify, distribute, sell, or lease any part of our products without our express written permission.

By submitting feedback, suggestions, or ideas to us, you grant us a perpetual, irrevocable, royalty-free licence to use that feedback in any way we choose.`,
              },
              {
                title: '8. Limitation of Liability',
                content: `To the maximum extent permitted by applicable law, Redcubical Systems shall not be liable for:

— Any indirect, incidental, special, or consequential damages
— Loss of profits, data, or business opportunities
— Damages arising from your use of or inability to use our products
— Any errors or omissions in our products

Our total liability for any claim arising from these terms shall not exceed the amount you paid us in the three months preceding the claim.`,
              },
              {
                title: '9. Disclaimers',
                content: `Our products are provided "as is" without warranties of any kind, express or implied.

HealHub is a clinic management tool and does not provide medical advice. Clinical decisions remain the sole responsibility of the treating healthcare professional.

Suraksha provides fraud detection assistance but cannot guarantee complete protection against all forms of cyber fraud. Users must exercise their own judgement.

Vedant is an AI assistant and should not be treated as a substitute for human medical judgement.`,
              },
              {
                title: '10. Termination',
                content: `We may terminate or suspend your access to our products immediately, without prior notice, if you:

— Breach any of these Terms of Service
— Engage in fraudulent or illegal activity
— Fail to pay applicable subscription fees

Upon termination, your right to use our products ceases immediately. We will retain your data for 30 days post-termination, after which it will be permanently deleted unless required by law.`,
              },
              {
                title: '11. Governing Law',
                content: `These Terms of Service are governed by and construed in accordance with the laws of India. Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of Dehradun, Uttarakhand, India.`,
              },
              {
                title: '12. Changes to These Terms',
                content: `We reserve the right to modify these terms at any time. We will provide at least 30 days' notice of material changes by email or prominent notice on our website. Your continued use of our products after changes take effect constitutes acceptance of the revised terms.`,
              },
              {
                title: '13. Contact',
                content: `For questions about these Terms of Service:

Email: a.uniyal@redcubicalsystems.com
Phone: +91 9368487416
Address: Dev Heights, First Floor, Aman Vihar, Sahastradhara Road, Dehradun — 248001, Uttarakhand, India`,
              },
            ].map((section, i) => (
              <div key={i} style={{
                paddingBottom: '40px',
                borderBottom: '1px solid rgba(255,255,255,0.06)',
              }}>
                <h2 style={{
                  fontFamily: 'Barlow Condensed, sans-serif',
                  fontSize: '22px', fontWeight: '900',
                  color: '#fff', textTransform: 'uppercase',
                  marginBottom: '16px',
                }}>
                  {section.title}
                </h2>
                <div style={{
                  fontSize: '15px',
                  color: 'rgba(255,255,255,0.55)',
                  lineHeight: '1.85',
                  whiteSpace: 'pre-line',
                }}>
                  {section.content}
                </div>
              </div>
            ))}
          </div>

          {/* Back link */}
          <div style={{ marginTop: '64px', display: 'flex', gap: '16px' }}>
            <Link to="/" className="btn-outline"
              style={{ padding: '12px 24px', fontSize: '13px' }}>
              ← Back to Home
            </Link>
            <Link to="/contact" className="btn-blue"
              style={{ padding: '12px 24px', fontSize: '13px' }}>
              Contact Us →
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}